import './NA.scss';

export default function NA({ text = 'N/A', isItalic = false }) {
  return <span className='na' style={{ fontStyle: isItalic ? 'italic' : 'normal' }} >{ text }</span>
}
